// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ColorModeController from "./color_mode_controller"
application.register("color-mode", ColorModeController)

import ImageViewerCallerController from "./image_viewer_caller_controller"
application.register("image-viewer-caller", ImageViewerCallerController)

import ImagesCarouselController from "./images_carousel_controller"
application.register("images-carousel", ImagesCarouselController)

import MapController from "./map_controller"
application.register("map", MapController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalCallerController from "./modal_caller_controller"
application.register("modal-caller", ModalCallerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RadioNavigationController from "./radio_navigation_controller"
application.register("radio-navigation", RadioNavigationController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SearchMapController from "./search_map_controller"
application.register("search-map", SearchMapController)

import VisibilityTogglerController from "./visibility_toggler_controller"
application.register("visibility-toggler", VisibilityTogglerController)
